import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * This utility tells us when a certain amount of time has passed without an activity occurring.
 * The method activityHappened indicates a moment of activity.
 * The idleFunction will be called only after delayMsec has passed without any new activity.
 * cancelAnyActivity will treat all existing activity as if it hadn't happened - the idleFunction will
 * not be called until another activity happens.
 */
export class IdleTimer {
  constructor(delayMsec, idleFunction) {
    /**
     * handle needed to clean up a timer.
     */
    _defineProperty(this, "m_timerID", NaN);
    /**
     * function to call once the idle condition has been met
     */
    _defineProperty(this, "m_idleFunction", void 0);
    /**
     * duration of time without activity to meet idle condition
     */
    _defineProperty(this, "m_delayMsec", void 0);
    /**
     * For debugging only, timestamp of the last activity.
     */
    // @ts-ignore: noUnusedLocals
    _defineProperty(this, "m_lastActivity", 0);
    this.m_idleFunction = idleFunction;
    this.m_delayMsec = delayMsec;
  }

  /**
   * Regardless of whether there is outstanding activity that may begin a period of idleness,
   * forget about that activity, and don't call idleFunction again until another activity happens.
   */
  cancelAnyActivity() {
    if (!isNaN(this.m_timerID)) {
      clearTimeout(this.m_timerID);
      this.m_timerID = NaN;
      this.m_lastActivity = 0;
    }
  }

  /**
   * Indicate that activity has happened.
   * idleFunction will only be called after delayMsec has passed without more activity.
   */
  activityHappened() {
    // restart the timer
    this.cancelAnyActivity();
    this.m_timerID = setTimeout(() => {
      this.idleTimeout();
    }, this.m_delayMsec);
    this.m_lastActivity = Date.now();
  }
  idleTimeout() {
    clearTimeout(this.m_timerID);
    this.m_timerID = NaN;
    this.m_idleFunction();
  }
  isTimerPending() {
    return !isNaN(this.m_timerID);
  }
}
//# sourceMappingURL=IdleTimer.js.map
